module.exports = __webpack_public_path__ + "img/group-light.9f571317.png";